module.exports = __webpack_public_path__ + "img/qb_mobile.cf308358.png";